import React from 'react';
import { COLORS } from '../../../../../common/colors';

type MarcoBarType = {
    weekly: number;
    daily: number;
    max: number;
    type: 'CALORIES' | 'PROTEIN' | 'FAT' | 'CARBS' | 'SUGARS';
};

const transition = 'width 1s ease, background-color 1s ease, opacity 1s ease';

const styles = {
    CALORIES: { backgroundColor: COLORS.calories, transition },
    CALORIES_LIGHT: { backgroundColor: COLORS.caloriesLight, transition },
    PROTEIN: { backgroundColor: COLORS.protein, transition },
    PROTEIN_LIGHT: { backgroundColor: COLORS.proteinLight, transition },
    FAT: { backgroundColor: COLORS.fat, transition },
    FAT_LIGHT: { backgroundColor: COLORS.fatLight, transition },
    CARBS: { backgroundColor: COLORS.carb, transition },
    CARBS_LIGHT: { backgroundColor: COLORS.carbLight, transition },
    SUGARS: { backgroundColor: COLORS.sugar, transition },
    SUGARS_LIGHT: { backgroundColor: COLORS.sugarLight, transition },
};

const MacroBar = (props: MarcoBarType) => {
    const { weekly, daily, max, type } = props;

    const widthWeekly: number = (weekly / max) * 100;
    const widthToday: number = (daily / max) * 100;
    const over: boolean = widthToday >= widthWeekly;

    return (
        <div className="w-full h-6 relative">
            <div
                className="h-full absolute left-0 b-0"
                style={{ ...styles[`${type}_LIGHT`], width: `${widthWeekly}%` }}
            />
            <div
                className="h-full absolute left-0 b-0"
                style={{ ...styles[type], width: `${widthToday}%` }}
            />

            {/* this is to show 1 line of weekly number position */}
            <div
                className="h-full absolute left-0 b-0"
                style={{
                    width: `${widthWeekly}%`,
                    borderRight: '2px solid white',
                    opacity: over ? 0.3 : 0,
                }}
            />
        </div>
    );
};

export default MacroBar;
